import axios from "axios";
import tokenHelper from "./token";
import { Message } from 'element-ui'
import router from "../router";

const baseurl = process.env.NODE_ENV === 'production' ? 'http://yb.yuzanyun.com/proxy' : '/api';

// axios.defaults.baseURL = baseurl;
// axios.defaults.withCredentials = true;
// axios.defaults.headers["X-Requested-With"] = "XMLHttpRequest";
// axios.defaults.headers["content-type"] = "application/x-www-form-urlencoded;";

const service = axios.create({
    baseURL: baseurl, // api 的 base_url
    timeout: 30000, // request timeout
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'max-age=0'
    },
    // transformRequest: [
    //   data => {
    //     let ret = ''
    //     for (const it in data) {
    //       if (data[it] || data[it] === 0) {
    //         ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    //       }
    //     }
    //     return ret
    //   }
    // ]
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        const token = tokenHelper.getToken("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    },
);

service.interceptors.response.use(
    (response) => {
        return response.data
    },
    (error) => {
        if (error.response.status === 401) {
            router.push({
                path: '/visibilization/price',
                query: { login: 'false' }
            })
        }
        return Promise.reject(error);
    }

    //     res=>{
    //     console.log(res.data,'res.data')
    //     return res.data
    //     const code=res.data.code;
    //     const message=errorCode[code] || res.data.msg || errorCode['default']
    //     if(code===401){
    //         Message({
    //             message: message,
    //             type:'error'
    //         })
    //     }else if(code===500){
    //         Message({
    //             message: message,
    //             type:'error'
    //         })
    //         return Promise.reject(new Error(message))
    //     }else if(code !==200){
    //         Notification.error({
    //             title:message
    //         })
    //         return Promise.reject('error')
    //     }else{
    //         return res.data
    //     }
    // }
)

export default service;
